export const SUIVI_FACTURES_PAYEES = {
    SET_SCROLL: 'SET_SUIVI_FACTURES_PAYEES_SCROLL_POSITION',
    SET_ITEMS_PAYEES: 'SET_SUIVI_FACTURES_PAYEES_ITEMS',
    ADD_ITEMS: 'ADD_SUIVI_FACTURES_PAYEES_ITEMS',
    RESET_ITEMS: 'RESET_SUIVI_FACTURES_PAYEES_ITEMS',

    SET_PAGE_PAYEES: 'SET_SUIVI_FACTURES_PAYEES_PAGE',
    SET_NB_OF_PAGES_PAYEES: 'SET_SUIVI_FACTURES_PAYEES_NB_OF_PAGES',
    SET_SCROLL_PAYEES: 'SET_SUIVI_FACTURES_PAYEES_SCROLL',
    SET_COUNT_PAYEES: 'SET_SUIVI_FACTURES_PAYEES_COUNT',

    SET_SORT_PAYEES: 'SET_DEMANDE_FACTURES_PAYEES_SORT',

    SET_IS_LOADING_PAYEES: 'SET_SUIVI_FACTURES_PAYEES_IS_LOADING',
    SET_ERROR_PAYEES: 'SET_SUIVI_FACTURES_PAYEES_ERROR',
    SET_SUCCESS_PAYEES: 'SET_SUIVI_FACTURES_PAYEES_SUCCESS',

};
